<template>
  <read-event :name-route="nameRoute"/>

</template>

<script>
import ReadEvent from '../../../components/events/read-events'
export default {
  // name: 'ReadEvents',
  components: {
    ReadEvent
  },
  data () {
    return {
      nameRoute: ''
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.nameRoute = from.name
    })
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/app/events/read-events.view.vue